import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape, FormattedMessage } from 'react-intl';

import { RadioButton } from 'material-ui/RadioButton';

import Form from '../../UI/Form';
import FormTextField from '../../UI/FormTextField';
import FormCheckbox from '../../UI/FormCheckbox';
import FormRadioButtonGroup from '../../UI/FormRadioButtonGroup';
import FormRaisedButton from '../../UI/FormRaisedButton';

import styles from './RegListForm.css';

class RegListForm extends Component {
    static propTypes = {
        intl: intlShape.isRequired,
        regList: PropTypes.object,
        editable: PropTypes.bool,
        onSubmit: PropTypes.func,
        season: PropTypes.string,
    };

    constructor(props) {
        super(props);

        this.state = {
            form: {
                ...props.regList,
            },
        };
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.regList !== this.props.regList) {
            this.setState({ form: { ...nextProps.regList } });
        }
    }

    handleFormValuesUpdate = form => {
        this.setState({ form });
    };

    handleFormSubmit = form => {
        const { season } = this.props;

        this.setState({ saving: true });

        this.props.onSubmit && this.props.onSubmit({ season, ...form });
    };

    render() {
        const {
            intl: { formatMessage },
            editable,
            season,
        } = this.props;
        const { form, saving } = this.state;

        return (
            <Form
                labelIdPrefix="RegList"
                form={form}
                onFormValuesUpdate={this.handleFormValuesUpdate}
                onSubmit={this.handleFormSubmit}
                editable={editable}
            >
                <h3 className={styles.subheader}>
                    <FormattedMessage id="RegList.town info" />
                </h3>
                <FormTextField name="townName" required disabled />
                <FormTextField name="population" required numberOnly />
                <FormTextField name="lastGrade" required />
                <FormTextField name="orgHeadName" required />
                <FormTextField name="orgHeadPosition" required />
                <FormTextField name="juryHeadName" required={!!form.juryHeadPosition} />
                <FormTextField name="juryHeadPosition" required={!!form.juryHeadName} />
                <h3 className={styles.subheader}>
                    <FormattedMessage id="RegList.contact info" />
                </h3>
                <FormTextField name="address" multiLine required />
                <FormTextField name="addressee" required />
                <FormTextField name="email" disabled required />
                <FormTextField name="phone" required />
                <h3 className={styles.subheader}>
                    <FormattedMessage id="RegList.tournament info" />
                </h3>
                <FormTextField name="invitations" required />
                {season === 'fall' && (
                    <FormTextField
                        name="pDate"
                        className={styles.firstHalf}
                        required={form.pPapersNumber > 0 || form.sentPPapersNumber > 0}
                    />
                )}
                {season === 'fall' && (
                    <FormTextField
                        name="mDate"
                        className={styles.secondHalf}
                        required={form.mPapersNumber > 0 || form.sentMPapersNumber > 0}
                    />
                )}
                {season === 'fall' && (
                    <FormTextField
                        name="pPapersNumber"
                        className={styles.firstHalf}
                        required={!!(form.pDate || form.sentPPapersNumber > 0)}
                        numberOnly
                    />
                )}
                {season === 'fall' && (
                    <FormTextField
                        name="mPapersNumber"
                        className={styles.secondHalf}
                        required={!!(form.mDate || form.sentMPapersNumber > 0)}
                        numberOnly
                    />
                )}
                {season === 'spring' && (
                    <FormTextField
                        name="tDate"
                        className={styles.firstHalf}
                        required={form.tPapersNumber > 0 || form.sentTPapersNumber > 0}
                    />
                )}
                {season === 'spring' && (
                    <FormTextField
                        name="vDate"
                        className={styles.secondHalf}
                        required={form.vPapersNumber > 0 || form.sentVPapersNumber > 0}
                    />
                )}
                {season === 'spring' && (
                    <FormTextField
                        name="tPapersNumber"
                        className={styles.firstHalf}
                        required={!!(form.tDate || form.sentTPapersNumber > 0)}
                        numberOnly
                    />
                )}
                {season === 'spring' && (
                    <FormTextField
                        name="vPapersNumber"
                        className={styles.secondHalf}
                        required={!!(form.vDate || form.sentVPapersNumber > 0)}
                        numberOnly
                    />
                )}
                <FormTextField name="participantsNumber" required numberOnly />
                {season === 'fall' && (
                    <FormTextField
                        name="sentPPapersNumber"
                        className={styles.firstHalf}
                        required={!!(form.pDate || form.pPapersNumber > 0)}
                        numberOnly
                    />
                )}
                {season === 'fall' && (
                    <FormTextField
                        name="sentMPapersNumber"
                        className={styles.secondHalf}
                        required={!!(form.mDate || form.mPapersNumber > 0)}
                        numberOnly
                    />
                )}
                {season === 'spring' && (
                    <FormTextField
                        name="sentTPapersNumber"
                        className={styles.firstHalf}
                        required={!!(form.tDate || form.tPapersNumber > 0)}
                        numberOnly
                    />
                )}
                {season === 'spring' && (
                    <FormTextField
                        name="sentVPapersNumber"
                        className={styles.secondHalf}
                        required={!!(form.vDate || form.vPapersNumber > 0)}
                        numberOnly
                    />
                )}
                <FormTextField name="sentParticipantsNumber" required numberOnly />
                <FormRadioButtonGroup name="payment" required>
                    <RadioButton
                        value="payment"
                        label={formatMessage({ id: 'RegList.town pays' })}
                        className={styles.radioButton}
                    />
                    <RadioButton
                        value="no_payment"
                        label={formatMessage({ id: 'RegList.town does not pay' })}
                        className={styles.radioButton}
                    />
                </FormRadioButtonGroup>
                {form.payment === 'payment' && <FormTextField name="paymentData" required />}
                <FormCheckbox name="rulesAreFollowed" className={styles.checkbox} />
                {!form.rulesAreFollowed && <FormTextField name="ruleBreakersList" required />}
                <FormTextField name="comments" multiLine />
                {editable && (
                    <FormRaisedButton
                        action="submit"
                        primary
                        label={formatMessage({ id: 'RegList.save' })}
                        className={styles.button}
                        disabled={saving}
                    />
                )}
            </Form>
        );
    }
}

export default injectIntl(RegListForm);



// WEBPACK FOOTER //
// ./src/Components/RegListForm/RegListForm.js